import { render, staticRenderFns } from "./ModalPrimary.vue?vue&type=template&id=e5ecb55e&"
import script from "./ModalPrimary.vue?vue&type=script&lang=js&"
export * from "./ModalPrimary.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrimary.vue?vue&type=style&index=0&id=e5ecb55e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports